// lib/helpers/sortByStartTime.js

/**
 * Sort array schedule berdasarkan start_time (format HH:mm)
 * Data tanpa start_time akan diletakkan paling akhir.
 * @param {Array} data - Array jadwal
 * @param {'asc'|'desc'} order - Urutan sort, default 'asc'
 * @returns {Array} data yang sudah diurutkan
 */
export function sortByStartTime(data, order = 'asc') {
  return data.slice().sort((a, b) => {
    // Fallback jika salah satu start_time kosong
    if (!a.start_time && !b.start_time) return 0;
    if (!a.start_time) return 1;
    if (!b.start_time) return -1;

    // Convert "HH:mm" ke total menit
    const [aHour, aMin] = a.start_time.split(':').map(Number);
    const [bHour, bMin] = b.start_time.split(':').map(Number);

    const aTotalMinutes = aHour * 60 + aMin;
    const bTotalMinutes = bHour * 60 + bMin;

    return order === 'asc' ? aTotalMinutes - bTotalMinutes : bTotalMinutes - aTotalMinutes;
  });
}
